/**
 * Created by Thomas Mark
 * Date: 2021-04-02
 * 
 * Hier können zum einen Schlagwörter verwaltet werden und zum anderen
 * können diese Schlagwörter dann einem Produkt zugeordnet werden.
 * 
 * Der Dialog steht nur im ADMIN-Modus zur Verfügung und über das
 * Toolbar "Filter / Schlagwörter" im Produkt-Detailsdialog gestartet
 * werden.
 *   
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import * as utils from "../../../basics/utils";
import * as appActions from "../../../store/actions/appActions";
import * as fileActions from "../../../store/actions/fileActions";
import * as settingActions from "../../../store/actions/settingActions";
import * as portfolioActions from "../../../store/actions/portfolioActions";
import { ModalTitle } from "../../partials/ModalTitle";
import TabPanel from "../../partials/TabPanel";

const styles = (theme) => ({
    form: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1)
        },
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
    },
    formControl: {
        marginTop: theme.spacing(1),
    },
    message: {
        color: 'rgb(238,60,54)'
    }
});
class ProductTagsModal extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'ProductTagsModal';

        this.state = {
            tabIndex: 0,
            editMode: false,
            newTag: '',
            meta: {
                subTitle: '',
                description: '',
                url: '',
                tags: {
                    theme: [],
                    product: []
                },
                details: []
            },
            validationError: false,
            validationMessage: "",
        }

        this.debug = false;
    }

    loadData = () => {
        const { currentProduct } = this.props.portfolio;
        const { settingList } = this.props.setting;

        if (currentProduct === null) return;

        const metaNode = currentProduct.children.filter(d => d.name === 'meta.json')
        if (metaNode.length > 0) {
            this.setState({ meta: metaNode[0].meta })
        }
        console.log('LOAD DATA:', settingList.tags)

        this.props.setTagSettings(settingList.tags);
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidUpdate(prevProps) {
        const { modalDialog } = this.props.app;

        if (modalDialog.dialog === this.component && modalDialog.dialog !== prevProps.app.modalDialog.dialog) {
            this.loadData();
        }
    }

    // ==========================================================================
    //
    // HELPER - SECTION
    //
    // ==========================================================================

    validateWidget = (id, value) => {
        this.debug && console.log(`validateWidget(${id}, ${value})`);

        let newState = { validationError: false, validationMessage: '' };

        // Feld 'name' prüfen
        if (id === 'name') {
            if (/[^-&öüäÖÜÄß\w+( +\w+)*$]/.test(value)) {
                newState = { validationError: true, validationMessage: 'Wert ist ungültig!' };
            }
        }

        this.debug && console.log(newState);

        this.setState(newState);
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { modalDialog, path, unitHeight } = this.props.app;
        const { tagSettings } = this.props.setting;
        const { meta, tabIndex, editMode, newTag, validationMessage } = this.state;
        const { classes } = this.props;

        const dialog = utils.getDialogByPath(path);

        if (!tagSettings) return null;
        if (!tagSettings['theme']) return null;
        if (!tagSettings['product']) return null;

        const itemHeight = unitHeight;

        const filterList = (tabIndex === 0) ? meta.tags.theme : meta.tags.product;

        const onCancel = () => {
            this.props.closeModalDialog(); // appAction.js
        }

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderItem = (d, i) => {

            const checkFilter = (filter) => {

                if (!meta['tags']) return false;
                if (!meta['tags']['theme']) return false;
                if (!meta['tags']['product']) return false;

                const filterResult = filterList.filter(value => value === filter)

                return filterResult.length > 0 ? true : false;
            }

            const styleStandard = { backgroundColor: 'rgb( 64, 66,  65)', color: 'white' };

            if (editMode) {

                const onDelete = () => {
                    let newTagSettings = tagSettings;
                    let newTheme = tagSettings['theme'];
                    let newProduct = tagSettings['product']

                    if (tabIndex === 0) {
                        newTheme = tagSettings['theme'].filter(v => v !== d);
                    } else {
                        newProduct = tagSettings['product'].filter(v => v !== d);
                    }

                    newTagSettings['theme'] = newTheme;
                    newTagSettings['product'] = newProduct;

                    this.props.setTagSettings(newTagSettings);
                }

                const style = Object.assign(styleStandard, utils.getStyleHeight(itemHeight, .45, .32, .25));

                return (
                    <div key={i} className="inline-block rounded px-2 py-1 mr-2 whitespace-no-wrap overflow-hidden" style={style} onClick={onDelete}>
                        <span>{d}&nbsp;×</span>
                    </div>
                )

            } else {

                const onSelect = () => {
                    let newMeta = meta;
                    let newFilterList = filterList;

                    checkFilter(d) ? newFilterList = filterList.filter(v => v !== d) : newFilterList.push(d);

                    newMeta['tags'][tabIndex === 0 ? 'theme' : 'product'] = newFilterList;

                    this.setState({ meta: newMeta })
                }

                const styleSelected = { backgroundColor: 'rgb(58, 133, 247)', color: 'white' };
                const style = Object.assign((checkFilter(d)) ? styleSelected : styleStandard, utils.getStyleHeight(itemHeight, .45, .32, .25));

                return (
                    <div key={i} className="inline-block bg-gray-200 rounded px-2 py-1 mr-2 whitespace-no-wrap overflow-hidden"
                        style={style} onClick={(e) => onSelect()}>{d}
                    </div>
                )
            }
        }

        const renderToolbar = () => {

            const onSave = () => {
                const onUploadSuccess = () => {
                    this.props.scanPortfolio(dialog.portfolio);
                    this.props.closeModalDialog(); // appAction.js
                }

                const onUploadError = (error) => {
                    console.log('onUpload() error:', error);
                }

                this.props.uploadJSON(path, 'meta.json', meta, onUploadSuccess, onUploadError);
            }

            const onToggleEditMode = () => {
                //this.props.getSetting();

                this.setState({ editMode: !editMode });
            }

            const onSaveSettings = () => {
                this.props.updateSetting('tags', tagSettings);

                this.setState({ editMode: !editMode });
            }

            if (editMode) {
                return (
                    <DialogActions>
                        <Button onClick={onToggleEditMode} variant="outlined" color="default" >Abbruch</Button>
                        <Button onClick={onSaveSettings} variant="contained" color="primary">Fertig</Button>
                    </DialogActions>
                )
            } else {
                return (
                    <DialogActions>
                        <Button onClick={onToggleEditMode} variant="outlined" color="default">Schlagwörter verwalten</Button>
                        <div className="flex-grow"></div>
                        <Button onClick={onCancel} variant="outlined" color="default" >Abbruch</Button>
                        <Button onClick={onSave} variant="contained" color="primary" >OK</Button>
                    </DialogActions>
                )
            }
        }

        const renderAddTag = () => {
            if (!editMode) return null;

            const onSubmit = (e) => {
                e.preventDefault();

                // nicht sichern, wenn Feld fehlerhaft!
                if (validationMessage !== '') return;

                let newTagSettings = tagSettings;
                let tagGroup = tabIndex === 0 ? 'theme' : 'product';

                if (newTagSettings[tagGroup].filter(v => v === newTag).length === 0) {
                    // newTag zur Tag-Gruppe hinzufügen
                    newTagSettings[tagGroup].push(newTag);

                    // CurrentSetting aktualisieren
                    this.props.setTagSettingsCurrent(newTagSettings);

                    // Feld zurücksetzen
                    this.setState({ newTag: '' });
                }
            }

            const onChange = (e) => {
                this.validateWidget(e.target.id, e.target.value);

                this.setState({ newTag: e.target.value });
            }

            return (
                <form className={classes.form} noValidate onSubmit={onSubmit}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            autoFocus
                            id="name"
                            autoComplete="off"
                            label="Neues Schlagwort"
                            type="text"
                            fullWidth={false}
                            disabled={false}
                            value={newTag}
                            onChange={onChange}
                            InputLabelProps={{ shrink: true }}
                            margin="normal"
                        />
                    </FormControl>
                </form>
            )

        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        if (modalDialog.dialog !== this.component) return null;

        const onTab = (e, index) => {
            this.setState({ tabIndex: index });
        }

        const dialogTitle = 'Filter / Schlagwörter ' + (editMode ? 'verwalten' : '');

        return (
            <div>
                <Dialog fullWidth={true} maxWidth="md" open={true} style={{ zIndex: 100 }}>
                    <ModalTitle onClose={onCancel}>{dialogTitle}</ModalTitle>
                    <DialogContent dividers>
                        <Tabs value={this.state.tabIndex} onChange={onTab} indicatorColor="primary" textColor="primary" centered >
                            <Tab label="Themenauswahl" />
                            <Tab label="Produktauswahl" />
                        </Tabs>
                        <div style={{ minHeight: 300 }}>
                            <TabPanel value={tabIndex} index={0} className='py-4'>
                                <div>{tagSettings.theme.map((d, i) => renderItem(d, i))}</div>
                                {renderAddTag()}
                            </TabPanel>
                            <TabPanel value={this.state.tabIndex} index={1} className='py-4'>
                                <div>{tagSettings.product.map((d, i) => renderItem(d, i))}</div>
                                {renderAddTag()}
                            </TabPanel>
                        </div>
                    </DialogContent>
                    {renderToolbar()}
                    <Typography className="w-full px-8" variant="h6" noWrap>
                        {validationMessage === '' ? <span>&nbsp;</span> : validationMessage}
                    </Typography>

                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        file: state.file,
        setting: state.setting,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, settingActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ProductTagsModal));